import { render } from "./AddButton.vue?vue&type=template&id=5a8d72e1"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__